import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { StaticContentHandler } from "./StaticContentHandler";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { FilterKey } from "@studyportals/search-filters";

export abstract class DisciplineHandler extends StaticContentHandler {

	protected async canHandle(filterState: FilterSelectionState, sortState: SortingState, disciplineId: string): Promise<boolean> {

		const metaRankingSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const onlyOneDisciplineSelected = await this.singleSelectionFor(FilterKey.DISCIPLINES, filterState);
		const onlyDisciplineFilterApplied = await this.selectionOnlyFor([FilterKey.DISCIPLINES], filterState);
		
		const disciplineValue = this.getFilterOptionValueBy(FilterKey.DISCIPLINES, filterState);

		return metaRankingSelected
			&& onlyDisciplineFilterApplied
			&& onlyOneDisciplineSelected
			&& disciplineValue === disciplineId;
	}
}